//NOTE autogenerated by export script
export {ActivitiesService as Activities} from './activities.service'
export {CollarLogEventsService as CollarLogEvents} from './collarLogEvents.service'
export {CurrentMaxIdService as CurrentMaxId} from './currentMaxId.service'
export {GPSPositionsService as GPSPositions} from './gPSPositions.service'
export {MortalitiesService as Mortalities} from './mortalities.service'
export {MortalityImplantsService as MortalityImplants} from './mortalityImplants.service'
export {ProximitiesService as Proximities} from './proximities.service'
export {SeparationsService as Separations} from './separations.service'
export {TrapEventsService as TrapEvents} from './trapEvents.service'
export {VaginalImplantsControllerService as VaginalImplants} from './vaginalImplantsController.service'
export {VirtualFenceEventsService as VirtualFenceEvents} from './virtualFenceEvents.service'
export {BASE_PATH} from '../variables'
export {ApiModule} from '../api.module'
export {EventsServices as Events} from './eventsService'
export {AllServices as All} from './allService'